import type { SlackChannelOption } from '@vy/types';
import { useSlackGetChannels } from '../../../../../../../hooks/requests/use-slack-channels';
import { isNotEmptyArray } from '@vy/utils';

export function useSlackChannelOptions() {
  const { data: channelsResponse, isLoading } = useSlackGetChannels({ suspense: false });
  const channels: SlackChannelOption[] = channelsResponse?.channels ?? [];

  return {
    channels,
    isLoading,
    hasChannels: isNotEmptyArray(channels),
  };
} 